export type StorageMode = 'local' | 'remote';

export interface StorageConfig {
  mode: StorageMode;
  workspaceRoot: string;
  imagesDir: string;
  projectId: string;
  lineupFile: string;
  levelsDir: string;
  apiBaseUrl: string;
}

// mode: 'local'  — all data stays in localStorage, no network calls to /api or GitHub.
//                  Use this during active editor development.
// mode: 'remote' — data is read/written via the ld-editor-backend API backed by GitHub.
//                  Requires GITHUB_TOKEN configured in ld-editor-backend on Cloudflare.
export const storageConfig: StorageConfig = {
  mode: 'remote',
  workspaceRoot: 'icons-match',
  imagesDir: 'images',
  projectId: 'icons-match',
  lineupFile: 'lineup.json',
  levelsDir: 'levels',
  apiBaseUrl: 'https://ld-editor-backend.pages.dev/api',
};
